export const pipeline = {
  getStatusColor: function(status) {
    switch (status) {
      case "SUCCESS":
        return "green";
      case "ERROR":
        return "red";
      case "CREATED":
        return "blue";
      case "IN_PROGRESS":
        return "orange";
      default:
        return "grey";
    }
  },
  getTypeColor: function(type) {
    switch (type) {
      case "input":
        return "blue";
      case "output":
        return "green";
      case "error":
        return "red";
      default:
        return "grey";
    }
  },
};
